import { Components } from '@mui/material';

export const chip: Components['MuiChip'] = {
  styleOverrides: {
    root: {
      fontWeight: 'bold',
    },
    filled: {
      boxShadow: '0px 2px 4px rgba(216, 216, 216, 0.5)',
    },
    sizeSmall: {
      fontSize: '12px',
    },
  },
};
